export const CREATIVE_REGISTRATION_CLOSED = true;

export const REJECTED_SAMPLES_RESUBMISSION_WINDOW = 6; // in months



// WEBPACK FOOTER //
// ./registration/constants.js